export default "__VITE_ASSET__Djpwjg6z__"